import React, { useState } from 'react';
import { fetchUtils, usePermissions } from 'react-admin';
import { CircularProgress, TextField, IconButton, Popover } from '@material-ui/core';
import { SearchOutlined } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';

const fetch = fetchUtils.fetchJson;
const requestOptions = {headers: new Headers()};

const useStyles = makeStyles({
  matchLink: {
    fontSize: 15,
    color: 'white',
    fontWeight:300,
    textDecoration: 'none'
  },
  searchInput: {
    '& label.Mui-focused': {
      color: 'white',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'white',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'white',
      },
      '&:hover fieldset': {
        borderColor: 'white',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'white',
      },
    },
  }
});

const campaignTypeMapping = {
  'CAMPAIGN': 'adcampaigns',
  'DEAL': 'deals',
  'AD_QUALITY_RULE': 'ad_quality_rules',
  'TRAFFIC RULE': 'campaigns',
  'PUBLISHER': 'publishers',
  'SITE': 'sites',
  'PLACEMENT': 'placements',
  'DOMAIN': 'domains',
  'BIDDER': 'bidders'
}

export const GlobalSearchInput = (props) => {
  const classes = useStyles(props);
  const { permissions } = usePermissions();
  let [results, setResults] = useState();
  let [anchorEl, setAnchorEl] = useState();
  let [value, setValue] = useState("");
  let [clicked, setClicked] = useState(false);

  const SearchIcon = () => 
    <IconButton size='small' onClick={search}>
      <SearchOutlined />
    </IconButton>

  const handleClose = (x) => {
    setAnchorEl(null)
  };

  const search = (input) => {
    setClicked(true);
    const token = localStorage.getItem('token');
    requestOptions.headers.set('Authorization', `Bearer ${token}`);
    const currentTarget = input.currentTarget.parentNode;
    const url = window.nobid_endpoint + `/global_search?term=${value}`;
  
    fetch(url, requestOptions).then(({ json }) => {
      setAnchorEl(currentTarget);
      setResults(json.data);
      setClicked(false);
    });
  }

  const keyPress = (e) => {
    if(e.keyCode == 13){
      search(e);
    }
 }

  const open = Boolean(anchorEl);

  return (permissions && ['admin', 'publisher'].includes(permissions.role)) ?
    <div style={{ position: 'relative' }} >
      <TextField
        id="outlined-bare"
        className={classes.searchInput}
        variant="outlined"
        label='Search'
        size='small'
        onKeyDown={keyPress}
        onChange={(e) => setValue(e.target.value)}
        hiddenLabel
        value={value}
        style={{zIndex: 1601, margin: '0 30px'}}
        InputProps={{
          endAdornment: (
            clicked ? <CircularProgress color="inherit" size={20}/> : <SearchIcon />
          ),
        }}
      />
      <Popover
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={handleClose}
        disableAutoFocus={true}
        disableEnforceFocus={true}
        InputLabelProps={{shrink: false}}
      >
        <ul style={{minWidth: 500, maxHeight: window.innerHeight - 100}}>
          { results && results.length > 0 ?
            results.map(x => 
              <li style={{listStyle: 'none', marginBottom: 20}}>
                <b>{x[0].split('_').join(' ')}</b>
                <ul>{x[1].map(v => {
                  const link = '#' + campaignTypeMapping[v.type] + '/' + v.code;
                  return <li>
                    <a className={classes.matchLink} href={link}>
                      {v.name}
                    </a>
                  </li>})}
                </ul>
              </li>
            ) : 'No matches found'
          }
        </ul>
      </Popover>
    </div>
  : null
};
